module.exports = __webpack_public_path__ + "static/media/outputValue.f71f01c3.svg";